import { TrainingLaunch } from '../../models/TrainingLaunch';
import { TrainingRepository } from '../../repositories/TrainingRepository';

export class GetUserLaunchesUseCase {
  constructor(private trainingRepository: TrainingRepository) {}

  async execute(userId: string): Promise<TrainingLaunch[]> {
    return this.trainingRepository.getUserLaunches(userId);
  }
}
